import moment from 'moment';
import { ReactElement, useEffect, useState } from 'react';
import 'moment-timezone';
import { useData } from '../context/data.context';

type DashboardSyncCountDownProps = {
  lastSynced: Date | null;
};

/**
 * DashboardSyncCountDown component to render countdown of last sync time.
 * @param props - Properties of DashboardSyncCountDown component.
 * @returns - Reactelement.
 */
export default function DashboardSyncCountDown(props: DashboardSyncCountDownProps): ReactElement {
  const { lastSynced } = props;
  const { userConfigData } = useData();
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const [currentTime, setCurrentTime] = useState<Date | null>(null);
  const timeZone = userConfigData?.timeZone || 'America/New_York';
  useEffect(() => {
    setCurrentTime(new Date());
    const intervalId = setInterval(() => {
      setCurrentTime(new Date());
    }, 30000);
    return () => clearInterval(intervalId);
  }, [lastSynced]);
  return (
    <div className="flex items-center text-gray-400 text-xs font-normal dark:text-gray-400">
      {lastSynced
        ? `Last synced at ${moment(lastSynced).tz(timeZone).format('hh:mm:ss A')}`
        : 'Not synced yet'}
    </div>
  );
}
